import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {browserHistory} from 'react-router';
import {Button} from 'reactstrap';

export default class NavigationButton extends PureComponent {

    static propTypes = {
        path: PropTypes.string,
        onClick: PropTypes.func,
        children: PropTypes.node,
    };

    handleClick = () => {
        const {path} = this.props;
        if (path != null) {
            browserHistory.push(serverContextPath + path);
        }
    };

    render() {
        const {path, onClick, children, ...otherProps} = this.props;
        return <Button onClick={onClick || this.handleClick} {...otherProps}>{children}</Button>;
    }

}
